import type { SVGProps } from 'react';

const AlertIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      viewBox="0 0 16 16"
      width="1em"
      height="1em"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      {...props}
    >
      <rect width="16" height="16" rx="4" fill="#FC8A53" />
      <path
        d="M7.14282 11.9105C7.14282 12.1378 7.23313 12.3559 7.39387 12.5166C7.55462 12.6773 7.77264 12.7676 7.99997 12.7676C8.22729 12.7676 8.44531 12.6773 8.60606 12.5166C8.7668 12.3559 8.85711 12.1378 8.85711 11.9105C8.85711 11.6832 8.7668 11.4652 8.60606 11.3044C8.44531 11.1437 8.22729 11.0534 7.99997 11.0534C7.77264 11.0534 7.55462 11.1437 7.39387 11.3044C7.23313 11.4652 7.14282 11.6832 7.14282 11.9105ZM7.57139 9.66051H8.42854C8.48747 9.66051 8.53568 9.61229 8.53568 9.55336V3.33908C8.53568 3.28015 8.48747 3.23193 8.42854 3.23193H7.57139C7.51247 3.23193 7.46425 3.28015 7.46425 3.33908V9.55336C7.46425 9.61229 7.51247 9.66051 7.57139 9.66051Z"
        fill="white"
      />
    </svg>
  );
};

export default AlertIcon;
